document.addEventListener('DOMContentLoaded', function() {
  // Get DOM elements
  const shippingCountry = document.getElementById('AddressCountry_Shipping');
  const countryState = document.getElementById('AddressProvince_shipping');
  const shippingCountryZip = document.getElementById('ShippingAddressZip');
  const shippingRatePackage = document.querySelector('.shipping_rate_package');
  const shippingAddressWrapper = document.querySelector('.shipping_rate_message');
  const shippingAddressCount = document.querySelector('.shipping_address_count');
  const item = document.querySelector('.shipping_calc_save');
  const countrySelectsShipping = document.querySelectorAll('data-address-country-select');

  // ✅ Exit early if the shipping calculator doesn't exist on this page
  if (!item || !shippingCountry || !shippingRatePackage) return;

  // ✅ Initialize country/province selector only if elements exist
  if (
    window.Shopify &&
    Shopify.CountryProvinceSelector &&
    document.getElementById('AddressCountry_Shipping')
  ) {
    new Shopify.CountryProvinceSelector(
      'AddressCountry_Shipping',
      'AddressProvince_shipping',
      { hideElement: 'AddressProvinceContainerNewShiping' }
    );
  }

  // ✅ Safely add click listener
  item.addEventListener('click', () => {
    // Clear previous results
    if (shippingRatePackage) shippingRatePackage.innerHTML = '';

    // Check if a valid country is selected
    if (shippingCountry && shippingCountry.value !== '---') {
      item.classList.add('loading');

      // Build fetch URL safely using optional chaining and defaults
      const zip = encodeURIComponent(shippingCountryZip?.value || '');
      const country = encodeURIComponent(shippingCountry?.value || '');
      const province = encodeURIComponent(countryState?.value || '');

      fetch(`/cart/shipping_rates.json?shipping_address%5Bzip%5D=${zip}&shipping_address%5Bcountry%5D=${country}&shipping_address%5Bprovince%5D=${province}`)
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            throw new Error(window.shipping?.wrong_message || 'Unable to retrieve shipping rates.');
          }
        })
        .then((response) => {
          item.classList.remove('loading');

          if (!shippingAddressWrapper || !shippingAddressCount) return;

          shippingAddressWrapper.classList.remove('no-js-inline');
          shippingAddressCount.innerText = `${response.shipping_rates.length}`;

          // Render shipping rates
          if (Array.isArray(response.shipping_rates)) {
            response.shipping_rates.forEach((rate) => {
              const text = document.createElement('p');
              text.className = 'mb-0';
              text.innerText = `${rate.name}: ${window.shopCurrencySymbol || ''}${rate.price}`;
              shippingRatePackage?.appendChild(text);
            });
          }
        })
        .catch((e) => {
          item.classList.remove('loading');
          if (shippingAddressWrapper && shippingRatePackage) {
            shippingAddressWrapper.classList.add('no-js-inline');
            shippingRatePackage.innerHTML = `<p class="error mt-15">${e.message || e}</p>`;
          }
        });
    } else {
      if (shippingAddressWrapper && shippingRatePackage) {
        shippingAddressWrapper.classList.add('no-js-inline');
        shippingRatePackage.innerHTML = `<p class="error mt-15">${window.shipping?.country_label || 'Please select a country.'}</p>`;
      }
    }
  });
});
